import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  PublicSettingsResponse,
  CompanySettings,
} from "../../interface/public.interface";

class SettingsService {
  /**
   * 🏢 GET SETTINGS
   */
  async getSettings(): Promise<CompanySettings> {
    const response = await apiClient.get<PublicSettingsResponse>(
      env.PUBLIC_SETTINGS_URL
    );

    return response.data.data.settings;
  }
}

export const publicSettingsService = new SettingsService();